import React, { useCallback } from 'react';
import styled from 'styled-components';

import { ReactComponent as Left } from 'images/icons/chevron-double-left.svg';
import { ReactComponent as Right } from 'images/icons/chevron-double-right.svg';

import { Trans } from '@lingui/react/macro';
import { Button } from 'ui-kit/Button';
import { ModernIcon } from './Icon';

export const LIMITS = [50, 100, 200, 400];

interface PaginationProps {
  onNext?: () => void;
  onPrevious?: () => void;
  className?: string;
  limits?: number[];
  value?: number;
  onLimitChange?: (value: number) => void;
}

function Pagination({
  onNext,
  onPrevious,
  className,
  limits = LIMITS,
  value,
  onLimitChange
}: PaginationProps) {
  const hasLimits = !!onLimitChange;
  const onChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
    (e) => onLimitChange?.(+e.target.value),
    [onLimitChange]
  );
  const prev = useCallback(() => onPrevious?.(), [onPrevious]);
  const next = useCallback(() => onNext?.(), [onNext]);

  const limitsSelect = (
    <select value={value || ''} onChange={onChange}>
      {limits.map((l) => (
        <option key={l}>{l}</option>
      ))}
    </select>
  );

  return (
    <ul className={className}>
      <li hidden={!onPrevious}>
        <Button variant="phantom" onClick={prev}>
          <ModernIcon className="icon" icon={Left} />
        </Button>
      </li>
      <span />
      <div>
        {hasLimits && (
          <Trans>
            Показывать
            {limitsSelect}
            записей
          </Trans>
        )}
      </div>
      <li hidden={!onNext}>
        <Button variant="phantom" onClick={next}>
          <ModernIcon className="icon" icon={Right} />
        </Button>
      </li>
    </ul>
  );
}

const StyledPagination = styled(Pagination)`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  list-style: none;
  padding: 0;
  & > * {
    &:first-child {
      margin-right: 1em;
    }
    &:last-child {
      margin-left: 1em;
    }
  }
  & > span {
    flex: 1;
  }

  .icon {
    font-size: 1.5em;
  }

  [hidden] {
    display: block !important;
    visibility: hidden;
  }
`;

export default Object.assign(StyledPagination, { defaultLimit: LIMITS[0] });
